__turbopack_context__.v({
  "drawer": "ScrollableDrawer-module-scss-module__iGyBTa__drawer",
  "isClosing": "ScrollableDrawer-module-scss-module__iGyBTa__isClosing",
  "isFadingOut": "ScrollableDrawer-module-scss-module__iGyBTa__isFadingOut",
  "isOpen": "ScrollableDrawer-module-scss-module__iGyBTa__isOpen",
  "listingsBackdrop": "ScrollableDrawer-module-scss-module__iGyBTa__listingsBackdrop",
});
